import { useEffect } from 'react';
import { isWaitingForConfirmation } from './itemCheckers';
import { useBeepNotification } from './useBeepNotification';
import CONTENT from '../ui/content.json';

export const useNotificationForConfirmation = (transcript?: connect.ChatTranscriptItem[]): void => {
  const { playBeep } = useBeepNotification();
  const lastTranscriptItem = transcript?.[transcript.length - 1];

  useEffect(() => {
    if (!lastTranscriptItem) {
      return;
    }

    const originalTitle = window.parent.document.title;

    const clear = (): void => {
      if (window.parent.document.title.includes(CONTENT.newMessageLabel)) {
        window.parent.document.title = window.parent.document.title.replace(CONTENT.newMessageLabel, '');
      }
    };

    if (isWaitingForConfirmation(lastTranscriptItem)) {
      playBeep();
      window.parent.document.title = `${CONTENT.newMessageLabel}${originalTitle}`;
    } else {
      clear();
    }

    return () => {
      clear();
    };
  }, [playBeep, lastTranscriptItem]);
};
